import React from "react";
import content from "../content";

const HERO_IMG =
    "https://static.wixstatic.com/media/913191_b4068a14687948e6b6c5c5c566cd2e83~mv2.jpg/v1/fill/w_1905,h_993,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/913191_b4068a14687948e6b6c5c5c566cd2e83~mv2.jpg";

export const Hero = () => {
    const { hero, contact } = content;
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative h-screen min-h-[680px] w-full overflow-hidden"
        >
            <div
                className="absolute inset-0 animate-slow-zoom"
                style={{
                    backgroundImage: `url(${HERO_IMG})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/40 to-black/70" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_30%,_rgba(44,30,22,0.55)_100%)]" />

            <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6 sm:px-10">
                <p
                    data-testid="hero-overline"
                    className="text-[#D2B48C] text-xs sm:text-sm uppercase tracking-[0.45em] mb-6 animate-fade-in"
                >
                    {hero.overline}
                </p>
                <h1
                    data-testid="hero-title"
                    className="font-serif text-white text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-light leading-[1.05] max-w-5xl text-balance animate-fade-up"
                    style={{ animationDelay: "120ms" }}
                >
                    {hero.title}
                    <span className="block italic font-light text-[#E8D5B7]">
                        {hero.titleItalic}
                    </span>
                </h1>
                <p
                    data-testid="hero-subtitle"
                    className="mt-8 max-w-2xl text-white/90 text-base sm:text-lg leading-relaxed animate-fade-up"
                    style={{ animationDelay: "260ms" }}
                >
                    {hero.subtitle}
                </p>

                <div
                    className="mt-12 flex flex-col sm:flex-row items-center gap-4 sm:gap-6 animate-fade-up"
                    style={{ animationDelay: "400ms" }}
                >
                    <a
                        href={contact.reservationUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="hero-reserve-btn"
                        className="group inline-flex items-center justify-center px-10 py-4 bg-[#5C4033] text-[#F9F8F6] text-xs uppercase tracking-[0.3em] font-semibold border border-[#5C4033] hover:bg-transparent hover:text-white transition-all duration-500 min-w-[220px]"
                    >
                        {hero.primaryCta}
                    </a>
                    <a
                        href={contact.menuPdfUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="hero-menu-btn"
                        className="group inline-flex items-center justify-center px-10 py-4 bg-transparent text-white text-xs uppercase tracking-[0.3em] font-semibold border border-white/70 hover:bg-white hover:text-[#5C4033] transition-all duration-500 min-w-[220px]"
                    >
                        {hero.secondaryCta}
                    </a>
                </div>

                {/* Badge Maître Restaurateur */}
                <a
                    href="https://www.maitresrestaurateurs.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="hero-mr-badge"
                    aria-label="Membre de l'Association Française des Maîtres Restaurateurs"
                    title="Membre de l'Association Française des Maîtres Restaurateurs"
                    className="mt-12 inline-flex items-center bg-white/95 backdrop-blur-sm px-4 py-2.5 shadow-lg hover:bg-white transition-all duration-300 animate-fade-up"
                    style={{ animationDelay: "560ms" }}
                >
                    <img
                        src="https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/1rd2ykpt_Logo%20MR.jpg"
                        alt="Association Française des Maîtres Restaurateurs"
                        className="h-12 w-auto"
                    />
                </a>
            </div>

            <div className="absolute bottom-10 inset-x-0 z-10 flex justify-center">
                <div className="flex flex-col items-center gap-3 text-white/70 animate-fade-in" style={{ animationDelay: "900ms" }}>
                    <span className="h-12 w-px bg-white/50 relative overflow-hidden">
                        <span className="absolute top-0 left-0 h-4 w-full bg-white animate-[fade-in_1.4s_ease-in-out_infinite_alternate]" />
                    </span>
                </div>
            </div>
        </section>
    );
};
